import {ProductSellType} from '../api/enums';


export function prepareProductForResult(product) {
  return {
    id: product.id,
    pre_ticket_id: product.pre_ticket_id,
    type: product.type,
    card_id: product.card_id,
    sell_price: Number(product.in_house) + Number(product.airline)
  }
}


export function getCheckPaymentPs(selectedFlight) {
  //todo: refactor checkPaymentPs
  return selectedFlight.hasOwnProperty('checkPaymentPs') ? Number(selectedFlight.checkPaymentPs) / 100 : 0.035
}



/**
 * @param cards {Card[]}
 * @param products {Product[]}
 * @return {Product[]}
 */

export const arrangeProductsWithCards = (cards=[], products=[]) => {

  const products_by_card = []

  for ( const card of cards) {
    const products_this_card = products.filter( product => !!product?.card_id && card?.card_id && product.card_id === card.card_id)
    products_by_card.push(products_this_card)
  }
  const no_card_products =  products.filter( product => !product?.card_id)
  products_by_card.push(no_card_products)

  return products_by_card.flat()
}

/**
 * @param products {Product[]}
 * @return {Boolean}
 */
export function isAddCKbyDefault (flightProducts){
  return flightProducts.some( product => {
    if (product?.sell_type) {
      return [ProductSellType.CK, ProductSellType.Award].includes(product.sell_type)
    }
    return false
  })
}


export const generateSplitParts = (products) => {
  const result = [0]
  let prev = 0
  for (const product of products) {

    const sell_price =  Number(product.in_house) + Number(product.airline)
    if (sell_price > 0) {
      const next = sell_price + prev
      result.push(next)
      prev = next
    }

  }
  return result
}


/**
 * @param array {[Number]} [array]- array of product sell_price
 * @return {typeof Number} - one selected amount
 */
export const getPriceSelectorAmount = (array, index) => {
  if (array.length === 1) {
    return array[0]
  }

  if (array.length < 3) {
    if (index === 0) {
      return array[1]
    }
    return array[0]
  }

  return array[Math.floor(array.length / 2)]
}






